import { CheckCircleIcon, ExclamationIcon, XCircleIcon } from "@heroicons/react/outline";
import { Fragment, useEffect, useState } from "react";

import { Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/solid";

type Props = {
  index: number;
  type: "success" | "error" | "warning";
  title: string;
  description?: string;
  timeout?: number;
}

export default function ToastNotification({index, type, title, description,timeout}:Props) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (timeout) {
      setTimeout(() => {
        setShow(false);
      }, timeout);
    }
  }, [timeout]);

  const displayIcon = (type:string) => {
    switch (type) {
      case 'warning':
        return <ExclamationIcon
            className="h-5 w-5 text-yellow-400"
            aria-hidden="true"
          />
      case 'error':
        return <XCircleIcon
            className="h-5 w-5 text-red-400"
            aria-hidden="true"
          />
      default:
        return <CheckCircleIcon
            className="h-5 w-5 text-green-500"
            aria-hidden="true"
          />;
    }
  }

  const alertStyle = (type:string) => {  
    switch (type) {
      case "warning":
        return " bg-yellow-50 text-yellow-600";
      case "error":
        return " bg-red-50 text-red-600";
      case "success":
        return " bg-green-50 text-green-600";
      default:
        return " bg-blue-50 text-blue-600";
    }
  }

  return (
      <Transition
        show={show}
        as={Fragment}
        enter="transform ease-out duration-300 transition"
        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div
          className={
            "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden " +
            alertStyle(type)
          }
        >
          <div className="p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0">{displayIcon(type)}</div>
              <div className="ml-3 w-0 flex-1 pt-0.5">
                <p className="text-sm font-medium">{title}</p>
                <p className="mt-1 text-sm">{description}</p>
              </div>
              <div className="ml-4 flex-shrink-0 flex">
                <button
                  type="button"
                  className="rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  onClick={() => {
                    setShow(false);
                  }}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>
  );
}
